import React from "react";
import styles from "./Success.module.css";
import shared from "../../styles/shared.module.css";

function Success({ onDone }) {
  return (
    <div className={styles.pageCenter}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <svg
            width="52"
            height="52"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <h2 className={styles.heading}>SUCCESSFUL</h2>
        <p className={styles.message}>
          Your application has been submitted. We'll review it and contact you via e-mail with the next steps.
        </p>
        <button type="button" className={shared.primaryButtonFull} onClick={onDone}>Done</button>
      </div>
    </div>
  );
}

export default Success;